import { useEffect, useState, useRef, useCallback } from "react";
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  ListSubheader,
  Switch,
  FormControlLabel,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  addSession
} from "../../redux/actions";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DialogActions from '@mui/material/DialogActions';
import { Link } from "react-router-dom";
import { getFullName } from "../../common/utils/datatable";
import "./SessionCreation.css";
import moment from "moment";
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { toastOptions } from '../../common/utils/toasterOptions';
// import CustomDatePicker from "./CustomeDatePicker";

const STATUS_OPTIONS = [
  { value: 'Published', label: 'Published' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Draft', label: 'Draft' },
];

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "30rem",
      width: "10rem",
    },
  },
};

export const SessionCreation = (props) => {
  const [sessionName, setSessionName] = useState('');
  const [sessionDate, setSessionDate] = useState(dayjs());
  const [description, setDescription] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [selectedHosts, setSelectedHosts] = useState([]);
  const [selectedHostIds, setSelectedHostIds] = useState('');
  const [hasExternalHost, setHasExternalHost] = useState(false);
  const [externalHost, setExternalHost] = useState('');
  const [externalHostEmail, setExternalHostEmail] = useState(''); // Add email state for external hosts
  const [externalHosts, setExternalHosts] = useState([]); // Array to store multiple external hosts
  const [displayValue, setDisplayValue] = useState(''); // Add display value state
  const [forceUpdate, setForceUpdate] = useState(0); // Add force update counter
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedSkillsIds, setSelectedSkillsIds] = useState("");
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const { allUserDetails, userData } = useSelector(({ USER }) => USER);
  const { listItems } = useSelector(({ MODULES }) => MODULES);
  const [userMembers, setUserMembers] = useState(allUserDetails);
  const [userSkills, setUserSkills] = useState(listItems ? listItems.Skills : []);
  const [totalSeats, setTotalSeats] = useState(25);
  const [regStartDate, setRegStartDate] = useState(dayjs());
  const [regEndDate, setRegEndDate] = useState(dayjs());
  const [otherSkills, setOtherSkills] = useState("");
  const [isFeedbackEmailEnabled, setIsFeedbackEmailEnabled] = useState(true);
  const [status, setStatus] = useState('Draft'); // Default to Draft
  const dispatch = useDispatch();

  useEffect(() => {
    if (listItems && listItems.Skills && listItems.Skills.length) {
      setUserSkills(listItems.Skills);
    }
  }, [listItems]);
  useEffect(() => {
    if (allUserDetails && allUserDetails.length) {
      setUserMembers(allUserDetails);
    }
  }, [allUserDetails]);

  const handleClose = () => {
    props.onResponse(true);
  }

  const handleHostChange = (event) => {
    const {
      target: { value },
    } = event;
    
    // Check if "external" is being selected or deselected
    if (value.includes("external")) {
      // External facilitator is being selected
      setHasExternalHost(true);
      // Keep only the actual user objects, filter out "external" string
      const actualHosts = value.filter(v => v !== "external" && typeof v === 'object');
      setSelectedHosts(actualHosts);
      let ids = actualHosts.map((user) => user.id);
      setSelectedHostIds(ids.join(","));
    } else {
      // External facilitator is being deselected or not selected
      setHasExternalHost(false);
      setExternalHost("");
      setExternalHosts([]); // Reset external hosts array
      setSelectedHosts(value);
      let ids = value.map((user) => user.id);
      setSelectedHostIds(ids.join(","));
    }
  };
  const handleUserChangeSkills = (event) => {
    const {
      target: { value },
    } = event;
    if (value.findIndex((val) => val === "Select All") > -1) {
      if (selectAll) {
        setSelectedSkills([]);
        setSelectedSkillsIds("");
      } else {
        setSelectedSkills(listItems.Skills);
        let ids = listItems.Skills?.map((user) => {
          return user.longCodeValue;
        });
        setSelectedSkillsIds(ids.join(","));
      }
      setSelectAll(!selectAll);
    } else {
      setSelectedSkills(value);
      let ids = value.map((user) => {
        return user.longCodeValue;
      });
      setSelectedSkillsIds(ids.join(","));
    }
  };
  const getHostsNames = () => {
    console.log("getHostsNames called - hasExternalHost:", hasExternalHost, "externalHost:", externalHost);
    console.log("selectedHosts:", selectedHosts);
    console.log("externalHosts:", externalHosts);
    console.log("forceUpdate:", forceUpdate);
    
    let selectedNames = "";
    
    // Add internal hosts with email addresses
    if (selectedHosts && selectedHosts.length) {
      for (let i = 0; i < selectedHosts.length; i++) {
        // Use getFullName function to properly format names
        const fullName = getFullName(selectedHosts[i].firstName, selectedHosts[i].lastName);
        selectedNames += fullName + " (" + selectedHosts[i].email + ")";
        if (i !== selectedHosts.length - 1) selectedNames += ", ";
      }
    }
    
    // Add external hosts with optional email addresses
    if (externalHosts && externalHosts.length) {
      if (selectedNames) selectedNames += ", ";
      const externalNames = externalHosts.map(host => {
        if (typeof host === 'string') {
          return host; // Legacy format support
        }
        return host.hostName + (host.hostEmail ? ` (${host.hostEmail})` : '');
      });
      selectedNames += externalNames.join(", ");
    }
    
    // Show current typing external host name with optional email (real-time display)
    if (hasExternalHost && externalHost.trim()) {
      if (selectedNames) selectedNames += ", ";
      selectedNames += externalHost.trim();
      if (externalHostEmail.trim()) {
        selectedNames += ` (${externalHostEmail.trim()})`;
      }
    }
    
    console.log("Final selectedNames:", selectedNames);
    setDisplayValue(selectedNames); // Update display value
    return selectedNames;
  };
  const getSkillsName = () => {
    let selectedSkillsName = "";
    if (selectedSkills && selectedSkills.length) {
      for (let i = 0; i < selectedSkills.length; i++) {
        selectedSkillsName += `${selectedSkills[i].longCodeValue}`;
        if (i !== selectedSkills.length - 1) selectedSkillsName += ", ";
      }
    }
    return selectedSkillsName;
  };

  return (
    <div style={{ maxWidth: "100%", width: "100%", padding: "1rem", boxSizing: "border-box" }}>

      <div className="heading" style={{ marginBottom: "3rem" }}>
        Create Session
      </div>

      <div className="lineDivs">
        <div className="formDivs">
          <label style={{ marginRight: "1rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Session Name</label>
          <TextField
            label="Enter Name"
            required
            value={sessionName}
            onChange={(e) => setSessionName(e.target.value)}
            variant="outlined"
            margin="normal"
            InputProps={{ className: 'textareaInput', style: { height: '5rem' } }}
            style={{ width: "100%", maxWidth: "35rem", margin: "rem" }}
          />
        </div>

        <div className="formDivs">
          <label style={{ marginRight: "1rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Session Host(s)</label>
          <FormControl sx={{ width: "100%", maxWidth: "45rem" }}>
            <InputLabel required>
              Select Host(s)
            </InputLabel>
            <Select
              multiple
              value={selectedHosts}
              onChange={handleHostChange}
              renderValue={() => {
                getHostsNames(); // This will update displayValue
                return displayValue;
              }}
              displayEmpty
              style={{ height: "4rem", fontSize:"1.5rem", marginBottom: "2rem" }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 400,
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }}
            >
              {allUserDetails && allUserDetails.data && (
                <ListSubheader className="subheader">
                  <TextField
                    placeholder="Search Here..."
                    className="subheader-field"
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                    autoFocus={true}
                    onChange={(e) => {
                      setUserMembers({
                        ...allUserDetails,
                        data: allUserDetails.data.filter(
                          (i) =>
                          i.firstName?.toLowerCase().includes(e.target.value.toLowerCase()) ||
                          i.lastName?.toLowerCase().includes(e.target.value.toLowerCase()) ||
                          i.email?.toLowerCase().includes(e.target.value.toLowerCase())
                      ),
                      });
                    }}
                  />
                  {hasExternalHost && (
                    <div style={{ paddingTop: "1rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <TextField
                          placeholder="Enter External Facilitator Name"
                          required
                          value={externalHost}
                          onKeyDown={(e) => {
                            e.stopPropagation();
                            if (e.key === 'Enter' && externalHost.trim()) {
                              setExternalHost(externalHost.trim());
                            }
                          }}
                          InputProps={{
                            endAdornment: (
                              <span style={{ color: 'red' }}>*</span>
                            ),
                          }}
                          onChange={(e) => {
                            setExternalHost(e.target.value);
                            // Update display value immediately
                            let selectedNames = "";
                            
                            // Add internal hosts with email addresses
                            if (selectedHosts && selectedHosts.length) {
                              for (let i = 0; i < selectedHosts.length; i++) {
                                const fullName = getFullName(selectedHosts[i].firstName, selectedHosts[i].lastName);
                                selectedNames += fullName + " (" + selectedHosts[i].email + ")";
                                if (i !== selectedHosts.length - 1) selectedNames += ", ";
                              }
                            }
                            
                            // Add all previously added external hosts
                            if (externalHosts && externalHosts.length) {
                              if (selectedNames) selectedNames += ", ";
                              selectedNames += externalHosts.map(host => 
                                typeof host === 'string' ? host : host.hostName
                              ).join(", ");
                            }
                            
                            // Add current typing external host
                            if (hasExternalHost && e.target.value.trim()) {
                              if (selectedNames) selectedNames += ", ";
                              selectedNames += e.target.value.trim();
                            }
                            setDisplayValue(selectedNames);
                          }}
                          sx={{ width: "20rem" }}
                        />
                        <TextField
                          placeholder="Enter Email (Optional)"
                          value={externalHostEmail}
                          onKeyDown={(e) => {
                            e.stopPropagation();
                          }}
                          onChange={(e) => setExternalHostEmail(e.target.value)}
                          sx={{ width: "20rem" }}
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            if (externalHost.trim()) {
                              // Add to external hosts array with both name and email
                              const newExternalHost = {
                                hostName: externalHost.trim(),
                                hostEmail: externalHostEmail.trim() || null
                              };
                              setExternalHosts(prev => [...prev, newExternalHost]);
                              // Reset the input fields
                              setExternalHost('');
                              setExternalHostEmail('');
                              // Update display
                              setForceUpdate(prev => prev + 1);
                            }
                          }}
                          disabled={!externalHost.trim()}
                          sx={{ height: "3.5rem", minWidth: "6rem" }}
                        >
                          Add
                        </Button>
                      </div>
                      
                      {/* Display added external hosts */}
                      {externalHosts.length > 0 && (
                        <div style={{ 
                          background: "#f5f5f5", 
                          padding: "1rem", 
                          borderRadius: "4px",
                          maxHeight: "10rem",
                          overflowY: "auto"
                        }}>
                          <div style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "0.5rem" }}>
                            Added External Facilitators:
                          </div>
                          {externalHosts.map((host, index) => (
                            <div key={index} style={{ 
                              display: "flex", 
                              justifyContent: "space-between", 
                              alignItems: "center",
                              padding: "0.3rem 0",
                              borderBottom: index < externalHosts.length - 1 ? "1px solid #ddd" : "none"
                            }}>
                              <span>
                                {typeof host === 'string' ? host : 
                                  `${host.hostName}${host.hostEmail ? ` (${host.hostEmail})` : ''}`
                                }
                              </span>
                              <Button
                                size="small"
                                color="error"
                                onClick={() => {
                                  setExternalHosts(prev => prev.filter((_, i) => i !== index));
                                  setForceUpdate(prev => prev + 1);
                                }}
                                sx={{ minWidth: "auto", padding: "0.2rem" }}
                              >
                                ✕
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </ListSubheader>
              )}
              
              <MenuItem value="external">
                <Checkbox
                  checked={hasExternalHost}
                />
                <ListItemText primary="Others (External Facilitator)" />
              </MenuItem>
              
              {userMembers && userMembers.data &&
                userMembers.data.map((user) => (
                  <MenuItem
                    key={user.id}
                    value={user}
                  >
                    <Checkbox
                      checked={
                        selectedHosts.findIndex(
                          (person) => person.id === user.id
                        ) > -1
                      }
                    />
                    <ListItemText
                      primary={getFullName(user.firstName, user.lastName) + " (" +user.email + ")"}
                    />
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div style={{ width: "100%", marginBottom: "4rem" }}>
        <label style={{ marginBottom: "1rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Skill(s) Targetted</label>
        <FormControl sx={{ width: '100%' }}>
          <InputLabel required >Select Skill(s)</InputLabel>
          {/* {console.log(selectedSkills)} */}
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={selectedSkills}
            onChange={handleUserChangeSkills}
            input={<OutlinedInput label="Select User" />}
            renderValue={getSkillsName}
            MenuProps={MenuProps}
            style={{ height: "4rem", fontSize:"1.4rem" }}
          >
            {listItems && (
              <ListSubheader className="subheader">
                <TextField
                  placeholder="Search Here..."
                  className="subheader-field"
                  onKeyDown={(e) => {
                    e.stopPropagation();
                  }}
                  autoFocus={true}
                  onChange={(e) => {
                    setUserSkills(
                      listItems.Skills.filter((i) =>
                        i.longCodeValue
                          ?.toLowerCase()
                          .includes(e.target.value.toLowerCase())
                      )
                    );
                  }}
                />
                {selectedSkillsIds.includes("Others") ? (
                  <TextField
                    placeholder="Enter Other Skills"
                    required
                    value={otherSkills}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                    InputProps={{
                      endAdornment: (
                        <span style={{ color: 'red' }}>*</span>
                      ),
                    }}
                    autoFocus={true}
                    onChange={(e) => setOtherSkills(e.target.value)}
                    sx={{paddingTop:"1rem", width: "43.4rem"}}
                  />
                ):''}
              </ListSubheader>
            )}
            

            <div
              disabled={!selectedSkillsIds.length}
              style={{
                textAlign: "right",
                cursor: "pointer",
                height: "2rem",
              }}
            >
              <Link
                onClick={() => {
                  setSelectedSkills([]);
                  setSelectedSkillsIds("");
                  setSelectAll(false);
                }}
                style={{ color: "#1773bc", paddingRight: "1rem" }}
              >
                Clear Selection
              </Link>
            </div>

            {/* <MenuItem
              key={`select-all`}
              value={"Select All"}
              className="no-left-margin"
            >
              <Checkbox checked={selectAll} />
              <ListItemText
                primary={selectAll ? "Select None" : "Select All"}
              />
            </MenuItem> */}

            {userSkills && userSkills.length &&
              userSkills?.map((user) => (
                <MenuItem
                  key={user.id}
                  value={user}
                  className="no-left-margin"
                >
                  <Checkbox
                    checked={
                      selectedSkills.findIndex(
                        (person) => person.id === user.id
                      ) > -1
                    }
                  />
                  <ListItemText primary={user.longCodeValue} />
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>

      <div className="lineDivs" style={{ display: "flex", flexWrap: "nowrap", gap: "2rem", alignItems: "flex-end" }}>
        <div className="formDivs" style={{ flex: 1 }}>
          <label style={{ marginRight: "2rem", fontFamily: "Montserrat", fontSize: "1.3rem" }}>Session Date</label>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            sx={{
              width: '100%', 
              maxWidth: '35rem',
              "& label": {
                lineHeight: "0.8rem",
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <DatePicker
              className="custom-datepicker"
              style={{ height: "6rem" }}
              required
              label={
                <div>
                  Select Date{" "}
                  <span style={{ color: "red" }}>*</span>
                </div>
              }
              value={sessionDate}
              onChange={(newValue) => {
                setSessionDate(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  InputProps={{ style: { height: '6rem', fontSize:"1.5rem" } }}
                  style={{
                    width: "100%",
                    maxWidth: "35rem"
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
        
        <div className="formDivs" style={{ flex: 1 }}>
          <label style={{ marginRight: "2rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Total Seats</label>
          <TextField
            label="Enter Number of Seats"
            required
            value={totalSeats}
            onChange={(e) => setTotalSeats(e.target.value)}
            variant="outlined"
            margin="normal"
            InputProps={{ className: 'textareaInput', style: { height: '5rem', fontSize:"1.5rem" } }}
            style={{ width: "100%", maxWidth: "35rem", margin: "0rem" }}
          />
        </div>

        <div className="formDivs" style={{ flex: 1 }}>
          <label style={{ marginRight: "2rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Status</label>
          <FormControl sx={{ width: "100%", maxWidth: "35rem" }}>
            <InputLabel required>Select Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Select Status"
              style={{ height: "5rem", fontSize:"1.5rem" }}
            >
              {STATUS_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="lineDivs" style={{ display: "flex", flexWrap: "nowrap", gap: "2rem", alignItems: "flex-end" }}>
        <div className="formDivs" style={{ flex: 0.6 }}>
          <label style={{ marginRight: "1rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>
            Start Time<span style={{ color: "red", marginLeft: "4px" }}>*</span>
          </label>
          <TextField
            type="time"
            required
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            InputProps={{ style: { height: '5rem', fontSize:"1.5rem" } }}
            style={{ width: "100%", maxWidth: "20rem" }}
          />
        </div>
        
        <div className="formDivs" style={{ flex: 0.6 }}>
          <label style={{ marginRight: "1rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>
            End Time<span style={{ color: "red", marginLeft: "4px" }}>*</span>
          </label>
          <TextField
            type="time"
            required
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            InputProps={{ style: { height: '5rem', fontSize:"1.5rem" } }}
            style={{ width: "100%", maxWidth: "20rem" }}
          />
        </div>
      </div>

      <div className="lineDivs" style={{ display: "flex", flexWrap: "nowrap", gap: "2rem", alignItems: "flex-end" }}>
        <div className="formDivs" style={{ flex: 1 }}>
          <label style={{ marginRight: "1.5rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Registration Start Date</label>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            sx={{
              "& label": {
                lineHeight: "0.8rem",
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <DatePicker
              className="custom-datepicker"
              style={{ height: "4rem" }}
              required
              label={
                <div>
                  Select Date{" "}
                  <span style={{ color: "red" }}>*</span>
                </div>
              }
              value={
                regStartDate
              }
              onChange={(newValue) => {
                setRegStartDate(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  InputProps={{ style: { height: '5rem', fontSize:"1.5rem" } }}
                  style={{
                    width: "100%",
                    maxWidth: "35rem",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
        
        <div className="formDivs" style={{ flex: 1 }}>
          <label style={{ marginRight: "1.1rem", fontFamily: "Montserrat", fontSize: "1.2rem" }}>Registration End Date</label>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            sx={{
              "& label": {
                lineHeight: "0.8rem",
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <DatePicker
              className="custom-datepicker"
              style={{ height: "4rem" }}
              required
              label={
                <div>
                  Select Date{" "}
                  <span style={{ color: "red" }}>*</span>
                </div>
              }
              value={
                regEndDate
              }
              onChange={(newValue) => {
                setRegEndDate(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  InputProps={{ style: { height: '5rem', fontSize:"1.5rem" } }}
                  style={{
                    width: "100%",
                    maxWidth: "35rem",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </div>

      <div style={{ width: "100%", marginBottom: "2rem" }}>
        <label style={{ marginBottom: "1rem", display: "block", fontFamily: "Montserrat", fontSize: "1.2rem" }}>
          Description<span style={{ color: "red", marginLeft: "4px" }}>*</span>
        </label>
        <TextField
          placeholder="Description"
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          inputProps={{
            style: {
              minHeight: "1rem",
              maxHeight: "1rem",
              overflow: "scroll",
              overflowX: "hidden", 
              display: "block",
              fontSize: "1.4rem"
            },
            className: "sessionDescription",
          }}
          multiline
          fullWidth
          sx={{ width: "100%" }}
        />
      </div>

      <div style={{ width: "100%", marginBottom: "2rem" }}>
        <FormControlLabel
          control={
            <Switch
              checked={isFeedbackEmailEnabled}
              onChange={(e) => setIsFeedbackEmailEnabled(e.target.checked)}
              color="primary"
            />
          }
          label={
            <span style={{ fontFamily: "Montserrat", fontSize: "1.2rem", color: "#333" }}>
              Enable Feedback Email Notifications
            </span>
          }
          style={{ marginTop: "1rem" }}
        />
      </div>

      <div style={{ display: "flex", paddingTop: "2rem", justifyContent: "flex-end" }}>
        <Button
          onClick={
            () => {
              if(selectedSkillsIds.includes("Others"))
                if(!otherSkills){
                  toast.error("Please Fill Other Skills",toastOptions);
                  return
                }

              // Validate external host name if external host is selected
              if (hasExternalHost && externalHosts.length === 0 && !externalHost.trim()) {
                toast.error("Please add at least one external facilitator name", toastOptions);
                return;
              }

              // Prepare hosts array in the format expected by backend
              let hostsArray = [];
              
              // Add internal hosts (with employeeId)
              if (selectedHosts && selectedHosts.length) {
                selectedHosts.forEach(host => {
                  const fullName = getFullName(host.firstName, host.lastName);
                  hostsArray.push({
                    employeeId: host.id ? host.id.toString() : null,
                    hostId: host.id ? host.id.toString() : null,
                    hostName: fullName,
                    hostEmail: host.email,
                    isExternal: false,
                    externalHostName: null
                  });
                });
              }
              
              // Add external hosts (with externalHostName and optional email)
              if (hasExternalHost) {
                let allExternalHosts = [...externalHosts];
                if (externalHost.trim()) {
                  allExternalHosts.push({
                    hostName: externalHost.trim(),
                    hostEmail: externalHostEmail.trim() || null
                  });
                }
                allExternalHosts.forEach((host, idx) => {
                  // Generate a unique hostId for external hosts
                  const hostId = `EXT_GUEST_${Date.now()}${idx}`;
                  hostsArray.push({
                    hostId,
                    employeeId: null,
                    hostName: typeof host === 'string' ? host.trim() : host.hostName,
                    hostEmail: typeof host === 'object' && host.hostEmail ? host.hostEmail : null,
                    isExternal: true,
                    externalHostName: typeof host === 'string' ? host.trim() : host.hostName
                  });
                });
              }

              console.log("Final hostsArray being sent to backend:", hostsArray);

              let data = {
                sessionName: sessionName,
                hosts: hostsArray,
                targetedSkill: selectedSkillsIds?.replace(/Others/, otherSkills),
                sessionDate: sessionDate?.format("DD MMM YYYY"),
                startTime: startTime,
                endTime: endTime,
                description: description,
                saveOrPublish: status === 'Draft' ? 0 : 1,
                seatsAlloted: totalSeats,
                registrationStartDate: regStartDate?.format("DD MMM YYYY"),
                registrationEndDate: regEndDate?.format("DD MMM YYYY"),
                status: status,
                isFeedbackEmailEnabled: isFeedbackEmailEnabled
              }
              for (const key in data) {
                if (key!= "saveOrPublish" && key !== "hosts" && key !== "isFeedbackEmailEnabled" && !data[key]) {
                  let errMsg = key.replace(/([A-Z])/g, ' $1')
                  errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1)
                  errMsg = "Please Fill " + errMsg
                  toast.error(
                    errMsg,
                    toastOptions
                  );                  
                  return
                }
              }
              
              // Validate hosts array is not empty
              if (!data.hosts || data.hosts.length === 0) {
                toast.error("Please select at least one host", toastOptions);
                return;
              }
              
              dispatch(
                addSession(data)
              );
              handleClose()
            }
          }
          type="submit" variant="contained" color="primary" style={{ marginRight: "1rem", height: "3rem" }}>
          Save and Publish
        </Button>
        <Button
          onClick={
            () => {
              if(selectedSkillsIds.includes("Others"))
                if(!otherSkills){
                  toast.error("Please Fill Other Skills",toastOptions);
                  return
                }

              // Validate external host name if external host is selected
              if (hasExternalHost && externalHosts.length === 0 && !externalHost.trim()) {
                toast.error("Please add at least one external facilitator name", toastOptions);
                return;
              }

              // Prepare hosts array in the format expected by backend
              let hostsArray = [];
              
              // Add internal hosts (with employeeId)
              if (selectedHosts && selectedHosts.length) {
                selectedHosts.forEach(host => {
                  console.log("Processing internal host:", host);
                  console.log("Host firstName:", host.firstName);
                  console.log("Host lastName:", host.lastName);
                  const fullName = getFullName(host.firstName, host.lastName);
                  console.log("Generated fullName:", fullName);
                  
                  hostsArray.push({
                    employeeId: host.id.toString(),
                    hostName: fullName,
                    hostEmail: host.email,
                    isExternal: false
                  });
                });
              }
              
              // Add external hosts (with externalHostName and optional email)
              if (hasExternalHost) {
                let allExternalHosts = [...externalHosts];
                if (externalHost.trim()) {
                  allExternalHosts.push({
                    hostName: externalHost.trim(),
                    hostEmail: externalHostEmail.trim() || null
                  });
                }
                allExternalHosts.forEach(host => {
                  const hostData = {
                    isExternal: true,
                    hostName: typeof host === 'string' ? host.trim() : host.hostName
                  };
                  // Add email if available
                  if (typeof host === 'object' && host.hostEmail) {
                    hostData.hostEmail = host.hostEmail;
                  }
                  hostsArray.push(hostData);
                });
              }

              console.log("Final hostsArray being sent to backend:", hostsArray);

              let data = {
                sessionName: sessionName,
                hosts: hostsArray,
                targetedSkill: selectedSkillsIds?.replace(/Others/, otherSkills),
                sessionDate: sessionDate?.format("DD MMM YYYY"),
                startTime: startTime,
                endTime: endTime,
                description: description,
                saveOrPublish: 0, // Always save as draft for this button
                seatsAlloted: totalSeats,
                registrationStartDate: regStartDate?.format("DD MMM YYYY"),
                registrationEndDate: regEndDate?.format("DD MMM YYYY"),
                status: 'Draft', // Always set as Draft for this button
                isFeedbackEmailEnabled: isFeedbackEmailEnabled
              }
              for (const key in data) {
                if (key!= "saveOrPublish" && key !== "hosts" && key !== "isFeedbackEmailEnabled" && !data[key]) {
                  let errMsg = key.replace(/([A-Z])/g, ' $1')
                  errMsg = errMsg.charAt(0).toUpperCase() + errMsg.slice(1)
                  errMsg = "Please Fill " + errMsg
                  toast.error(
                    errMsg,
                    toastOptions
                  );                  
                  return
                }
              }
              
              // Validate hosts array is not empty
              if (!data.hosts || data.hosts.length === 0) {
                toast.error("Please select at least one host", toastOptions);
                return;
              }
              
              dispatch(
                addSession(data)
              );
              handleClose()
            }
          }
          type="submit" variant="outlined" style={{ marginRight: "1rem", height: "3.1rem",width:"22.2rem" }}>
          Save as Draft
        </Button>
        <Button onClick={
          () => {
            setSessionName('')
            setSelectedHosts([])
            setSelectedHostIds('')
            setHasExternalHost(false)
            setExternalHost('')
            setExternalHosts([]) // Reset external hosts array
            setSelectedSkills([])
            setSelectedSkillsIds("")
            setSessionDate(new Date())
            setRegStartDate(new Date())
            setRegEndDate(new Date())
            setTotalSeats(25)
            setDescription('')
            setStartTime('');
            setEndTime('');
            setStatus('Draft'); // Reset status to Draft
            handleClose()
          }
        }
          variant="contained" style={{ marginRight: "1rem", height: "2.9rem",background:"lightgray",color:"black" }} >Close</Button>

      </div>

    </div>
  );
};